export class Deduplicator<Key = string> {

    private keys = new Map<Key, number>();

    constructor(
        private timeout: number = 1_000,
        private prolongOnDuplicate: boolean = false,
    ) {
    }

    public isUnique(key: Key): boolean {
        const clearTimer: number | undefined = this.keys.get(key);

        if (clearTimer) {
            if (this.prolongOnDuplicate) {
                clearTimeout(clearTimer);
                this.setClear(key);
            }

            return false;
        }

        this.setClear(key);

        return true;
    }

    private setClear(key: Key): void {
        const timeout = setTimeout(() => {
            this.keys.delete(key);
        }, this.timeout);
        this.keys.set(key, timeout as any);
    }

}
